console.log('Loading customer reviews carousel script...');

function initCarousel() {
  console.log('Initializing carousels...');
  
  // Select ALL sections, not just the first one
  const sections = document.querySelectorAll('.reviews-transformation-section');
  
  if (!sections.length) {
    console.error('No customer reviews sections found');
    return;
  }
  
  console.log('Found', sections.length, 'review section(s)');
  
  // Initialize each section independently
  sections.forEach((section, index) => {
    const container = section.querySelector('.reviews-container');
    const prevButton = section.querySelector('.nav-button.prev');
    const nextButton = section.querySelector('.nav-button.next');
    
    console.log(`Section ${index + 1}:`, {
      container: !!container,
      prevButton: !!prevButton,
      nextButton: !!nextButton
    });
    
    if (!container || !prevButton || !nextButton) {
      console.error(`Carousel elements not found for section ${index + 1}`);
      return;
    }
    
    function getScrollAmount() {
      const firstCard = container.querySelector('.review-card');
      if (!firstCard) return 350;
      const cardWidth = firstCard.offsetWidth;
      const containerStyle = getComputedStyle(container);
      const gap = parseInt(containerStyle.gap) || 20;
      return cardWidth + gap;
    }
    
    function isAtEnd() {
      const scrollLeft = container.scrollLeft;
      const scrollWidth = container.scrollWidth;
      const clientWidth = container.clientWidth;
      return scrollLeft + clientWidth >= scrollWidth - 5;
    }
    
    function isAtBeginning() {
      return container.scrollLeft <= 5;
    }
    
    prevButton.addEventListener('click', function(e) {
      e.preventDefault();
      console.log(`Section ${index + 1}: Prev button clicked`);
      if (isAtBeginning()) {
        container.scrollTo({
          left: container.scrollWidth - container.clientWidth,
          behavior: 'smooth'
        });
      } else {
        const scrollAmount = getScrollAmount();
        container.scrollBy({
          left: -scrollAmount,
          behavior: 'smooth'
        });
      }
    });
    
    nextButton.addEventListener('click', function(e) {
      e.preventDefault();
      console.log(`Section ${index + 1}: Next button clicked`);
      if (isAtEnd()) {
        container.scrollTo({
          left: 0,
          behavior: 'smooth'
        });
      } else {
        const scrollAmount = getScrollAmount();
        container.scrollBy({
          left: scrollAmount,
          behavior: 'smooth'
        });
      }
    });
    
    console.log(`Section ${index + 1}: Navigation setup complete`);
  });
}

// Prevent multiple initializations
let carouselInitialized = false;

function safeInitCarousel() {
  if (carouselInitialized) return;
  carouselInitialized = true;
  initCarousel();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', safeInitCarousel);
} else {
  safeInitCarousel();
}